import React from 'react';
import '../../../static/styles/apiguide.scss';
import '../../../static/styles/dashboard.scss';

export default class UpdateLodgingProducts extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const col_number_9 = 9;
        const total_levels = 6;
        const level1 = 6;
        const level2 = 5;
        const level2_prefix = level1 - level2;
        const level3 = 4;
        const level3_prefix = level1 - level3;
        const level4 = 3;
        const level4_prefix = level1 - level4;
        const level5 = 2;
        const level6 = 1;
        const level5_prefix = level1 - level5;
        return (
            <div>
                <h3 className={"mb0 mt40"}>숙박 상품 업데이트</h3>

                <div className="blog-post-meta">
                    <span className="s-post">한개 이상의 숙박 상품 업데이트</span>
                    <h3 className="request-method">
                        <span className="label label-success">PUT</span>
                    </h3>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <td>Path</td>
                            <td>Example Endpoint</td>
                        </tr>
                        <tr>
                            <td>/v1/marketplace/travel/lodgings</td>
                            <td>
                                https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/travel/lodgings
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt10">
                    <h4>Request Parameters</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan={col_number_9} className="bold">Request Header</th>
                        </tr>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>Request-Vendor-Id</td>
                            <td>O</td>
                            <td>String</td>
                            <td>벤더 아이디 요청</td>
                        </tr>
                        <tr>
                            <th colSpan={col_number_9} className="bold">Body Parameter</th>
                        </tr>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr><td colSpan={level1}>lodgingUpdateDtos</td><td>X</td><td>List{'<LodgingUpdateDto>'}</td><td></td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>travelProductId</td><td>O</td><td>Long</td><td>여행상품 아이디</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>sellerProductId</td><td>X</td><td>String</td><td>판매자 자사사이트의 상품ID</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>nation</td><td>X</td><td>String</td><td>숙박 시설 국가 (기본값 : 한국)</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>name</td><td>O</td><td>String</td><td>숙박시설 이름 (최대 50자까지 입력 가능)</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>localName</td><td>X</td><td>String</td><td>Local Name</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>introduction</td><td>O</td><td>String</td><td>숙박시설 소개 (최대 2000자까지 입력 가능)</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>notice</td><td>X</td><td>String</td><td>숙박시설 공지사항 (최대 2000자까지 입력 가능) </td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>benefits</td><td>X</td><td>List</td><td>숙박시설 특별혜택 (최대 3개 / 최대 30자까지 입력 가능) </td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>regionKeyword</td><td>O</td><td>String</td><td>지역키워드</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>searchTags</td><td>X</td><td>List</td><td>검색태그 (최대 100자까지 입력 가능)</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>images</td><td>O</td><td>List</td><td>이미지</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>sellerUrl</td><td>O</td><td>String</td><td>판매자 이미지 URL</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>sellerUrlMethod</td><td>X</td><td>String</td><td>Method. Default: GET</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>representative </td><td>X</td><td>boolean</td><td>이미지가 상품 대표함, 상품당 단일 대표이미지 보유. Default: FALSE </td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>imageGroup</td><td>X</td><td>String</td>
                            <td>이미지 설명. Default:BASIC
                                <table className="table table-striped">
                                    <tbody>
                                    <tr><th>Optional Value</th><th>내외관/전경</th></tr>
                                    <tr><td>VIEW</td><td>내외관/전경</td></tr>
                                    <tr><td>FACILITY</td><td>부대시설</td></tr>
                                    <tr><td>RESTAURANT</td><td>식당</td></tr>
                                    <tr><td>ETC</td><td>기타</td></tr>
                                    <tr><td>ROOM</td><td>객실</td></tr>
                                    <tr><td>BASIC</td><td>기본</td></tr>
                                    </tbody>
                                </table>
                            </td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>description</td><td>X</td><td>String</td><td>이미지 설명</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>seq</td><td>X</td><td>int</td><td>이미지 순서</td></tr>


                        {/*<tr><td>&nbsp;</td><td colSpan={level2}>refundByBusinessDay</td><td>X</td><td>Boolean</td><td>refund by business day</td></tr>*/}
                        <tr><td>&nbsp;</td><td colSpan={level2}>cancelType</td><td>O</td><td>String</td>
                            <td>취소 환불 정책
                                <table className="table table-striped">
                                    <tbody>
                                    <tr><th>Optional Value</th><th>Description</th></tr>
                                    <tr><td>AUTO</td><td>자동취소</td></tr>
                                    <tr><td>APPROVAL</td><td>승인취소</td></tr>
                                    </tbody>
                                </table>
                                CancelType(취소종류) 별 취소마감시간 (숙박상품)
                                <table className="table table-striped">
                                    <tbody>
                                    <tr>
                                        <td>AUTO</td><td>자동취소: 비영업일(고객취소접수)기준 23:59​</td>
                                    </tr>
                                    <tr>
                                        <td>APPROVAL</td><td>승인취소: 영업일 기준 17:00</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>cancelPolicyNotice</td><td>X</td><td>String</td><td>취소 환불 유의사항</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>instantBooking</td><td>X</td><td>Boolean</td><td>실시간 예약 가능 여부 (기본값 : True)</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>additionalInfoPrompt</td><td>X</td><td>String</td><td>주문 추가정보  (쿠팡에서 주문시 고객에게 추가요청사항을 남기도록 요청해야하는경우, 주문 추가 정보를 남겨주세요. (예 : 방문방법과 시간을 남겨주세요 등))</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>usageGuide</td><td>X</td><td>String</td><td>usage guide</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>usageNotice</td><td>O</td><td>String</td><td>이용안내 및 유의사항</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>address</td><td>X</td><td>Object</td><td>숙박 시설 주소</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>latitude</td><td>X</td><td>double</td><td>위도, 데이터 범위(-90, 90)</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>longitude</td><td>X</td><td>double</td><td>경도, 데이터 범위(-180,180)</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>roadNameAddress</td><td>X</td><td>String</td><td>도로명 주소</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>landNumberAddress</td><td>X</td><td>String</td><td>지번 주소</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>nation</td><td>O</td><td>String</td><td>국가</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>province</td><td>X</td><td>String</td><td>도</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>city</td><td>O</td><td>String</td><td>시</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>district</td><td>O</td><td>String</td><td>구</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>town</td><td>X</td><td>String</td><td>도</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>zipCode</td><td>X</td><td>String</td><td>우편번호</td></tr>


                        <tr><td>&nbsp;</td><td colSpan={level2}>localAddress</td><td>X</td><td>Object</td><td>현지 주소</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>latitude</td><td>X</td><td>double</td><td>위도 , 데이터 범위(-90, 90)</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>longitude</td><td>X</td><td>double</td><td>경도, 데이터 범위(-180,180)</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>roadNameAddress</td><td>X</td><td>String</td><td>도로명 주소</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>landNumberAddress</td><td>X</td><td>String</td><td>지번 주소</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>nation</td><td>O</td><td>String</td><td>국가</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>province</td><td>X</td><td>String</td><td>도</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>city</td><td>O</td><td>String</td><td>시</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>district</td><td>O</td><td>String</td><td>구</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>town</td><td>X</td><td>String</td><td>도</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>zipCode</td><td>X</td><td>String</td><td>우편번호</td></tr>


                        <tr><td>&nbsp;</td><td colSpan={level2}>reservationNotifications</td><td>X</td><td>List</td><td>예약/취소 알림</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>type</td><td>O</td><td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr><th>Optional Value</th><th>Description</th></tr>
                                    <tr><td>PHONE</td><td>전화</td></tr>
                                    <tr><td>FAX</td><td>팩스</td></tr>
                                    <tr><td>EMAIL</td><td>이메일</td></tr>
                                    </tbody>
                                </table>
                            </td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>contactInfo</td><td>O</td><td>String</td><td>연락처</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>contactDescription</td><td>X</td><td>String</td><td>연락처 설명</td></tr>


                        <tr><td>&nbsp;</td><td colSpan={level2}>homepage</td><td>X</td><td>String</td><td>홈페이지</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>representativePhone</td><td>O</td><td>String</td><td>숙박시설 대표 전화</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>bookingInquiryPhone</td><td>X</td><td>String</td><td>예약 문의 전화. 제공되지 않으면 해당 데이터가 representativePhone과 동일함</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>cancelInquiryPhone</td><td>X</td><td>String</td><td>취소 문의 전화.제공되지 않으면 해당 데이터가 representativePhone과 동일함</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>emergencyPhone</td><td>X</td><td>String</td><td>휴대폰 긴급 연락처</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>trafficInfo</td><td>X</td><td>String</td><td>길안내</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>publicTransportInfo</td><td>X</td><td>String</td><td>랜드마크 안내</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>nearbyLandmarks</td><td>X</td><td>List</td><td>주변 관광지 정보</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>name</td><td>O</td><td>String</td><td>이름</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>latitude</td><td>X</td><td>Double</td><td>위도</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>longitude</td><td>X</td><td>Double</td><td>위도</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>distance</td><td>X</td><td>Integer</td><td>거리</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>distanceUnit</td><td>X</td><td>String</td>
                            <td>
                                <table className="table table-striped">
                                    <tbody>
                                    <tr><th>Optional Value</th><th>Description</th></tr>
                                    <tr><td>KILOMETER</td><td>킬로미터</td></tr>
                                    <tr><td>METER</td><td>미터</td></tr>
                                    </tbody>
                                </table>
                            </td></tr>


                        <tr><td>&nbsp;</td><td colSpan={level2}>amenities</td><td>X</td><td>List</td><td>객실 공통 구비 품목. 자세한 내용을 엑셀 파일을 참고해 주십시오.</td></tr>
                        <tr><td>&nbsp;</td><td colSpan={level2}>themes</td><td>X</td><td>List</td><td>테마정보. 자세한 내용을 엑셀 파일을 참고해 주십시오.</td></tr>


                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title"></h3>
                            <a data-toggle="collapse" href = "#createTourDto">Request Body</a>
                        </div>
                        <div id = "createTourDto" className = "panel-collapse collapse">
                            <div id = "createTourDto" className="panel-body">
                    <pre className="ty01">
                        {`
{
  "lodgingUpdateDtos": [
    {
      "travelProductId": 579968859277099012,
      "additionalInfoPrompt": "changed: additional info prompt",
      "address": {
        "city": "shanghai-2",
        "district": "district",
        "landNumberAddress": null,
        "latitude": 32.260077,
        "longitude": 122.448697,
        "nation": "CN",
        "province": "shanghai-2",
        "roadNameAddress": "Shanghai 상하이 shanghaihutail617-2",
        "town": null,
        "zipCode": "200000-2"
      },
      "amenities": [
        "ACCOMMODATION_LEISURE_43",
        "ACCOMMODATION_LEISURE_57",
        "ACCOMMODATION_COMFORT_37"
      ],
      "benefits": [
        "benefit 3",
        "benefit 4"
      ],
      "bookingInquiryPhone": "010-2345-6789",
      "cancelInquiryPhone": "010-2345-6789",
      "cancelPolicyNotice": "cancel policy notice-2",
      "cancelType": "AUTO",
      "emergencyPhone": "010-2345-6789",
      "homepage": "www.example.com",
      "images": [
        {
          "description": null,
          "imageGroup": "VIEW",
          "representative": true,
          "sellerImageCategory": null,
          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/bffc831a_z.jpg",
          "sellerUrlMethod": "GET",
          "seq": 0
        },
        {
          "description": null,
          "imageGroup": "ROOM",
          "representative": false,
          "sellerImageCategory": null,
          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/db272720_z.jpg",
          "sellerUrlMethod": "GET",
          "seq": 1
        },
        {
          "description": null,
          "imageGroup": "VIEW",
          "representative": false,
          "sellerImageCategory": null,
          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/d9b82d75_z.jpg",
          "sellerUrlMethod": "GET",
          "seq": 2
        },
        {
          "description": null,
          "imageGroup": "VIEW",
          "representative": false,
          "sellerImageCategory": null,
          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/6ad13a4d_z.jpg",
          "sellerUrlMethod": "GET",
          "seq": 3
        },
        {
          "description": null,
          "imageGroup": "ROOM",
          "representative": false,
          "sellerImageCategory": null,
          "sellerUrl": "https://i.travelapi.com/hotels/15000000/14740000/14736800/14736767/3394096f_z.jpg",
          "sellerUrlMethod": "GET",
          "seq": 4
        }
      ],
      "instantBooking": true,
      "introduction": "product introduction - 2",
      "localAddress": null,
      "localName": "假日酒店_11",
      "name": "하이 인_update_1",
      "nation": "CN",
      "nearbyLandmarks": [
        {
          "distance": 1,
          "distanceUnit": "KILOMETER",
          "latitude": 31,
          "longitude": 121,
          "name": "nearbyLandmark 1"
        },
        {
          "distance": 500,
          "distanceUnit": "METER",
          "latitude": 31.1,
          "longitude": 121.1,
          "name": "nearbyLandmark 1"
        }
      ],
      "notice": "product notice - 2",
      "publicTransportInfo": "public transport infomation - 2",
      "refundByBusinessDay": true,
      "regionKeyword": "Shanghai",
      "representativePhone": "010-2345-6789",
      "reservationNotifications": [
        {
          "contactDescription": "reservation notification 1 - 2",
          "contactInfo": "010-2345-7777",
          "type": "PHONE"
        }
      ],
      "searchTags": [
        "shanghai",
        "disney"
      ],
      "sellerProductId": "seller product 1",
      "themes": [
        "ACCOMMODATION_THEME_65"
      ],
      "trafficInfo": "traffic info - 2",
      "usageGuide": "usage guide - 2",
      "usageNotice": "usage notice - 2"
    },
    {
      "travelProductId": 577175634321604613,
      "additionalInfoPrompt": "changed: additional info prompt",
      "address": {
        "city": "shanghai-3",
        "district": "Pudong New distict",
        "landNumberAddress": null,
        "latitude": 32.260077,
        "longitude": 122.448697,
        "nation": "CN",
        "province": "shanghai-2",
        "roadNameAddress": "Shanghai 상하이 shanghaihutail617-2",
        "town": null,
        "zipCode": "200000-2"
      },
      "amenities": [
        "ACCOMMODATION_LEISURE_43",
        "ACCOMMODATION_LEISURE_57",
        "ACCOMMODATION_COMFORT_37"
      ],
      "benefits": [
        "benefit 3",
        "benefit 4"
      ],
      "bookingInquiryPhone": "010-2345-6789",
      "cancelInquiryPhone": "010-2345-6789",
      "cancelPolicyNotice": "cancel policy notice-2",
      "cancelType": "AUTO",
      "emergencyPhone": "010-2345-7777",
      "homepage": "www.example.com",
      "images": [
        {
          "description": null,
          "imageGroup": "VIEW",
          "representative": true,
          "sellerImageCategory": null,
          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/bffc831a_z.jpg",
          "sellerUrlMethod": "GET",
          "seq": 0
        },
        {
          "description": null,
          "imageGroup": "ROOM",
          "representative": false,
          "sellerImageCategory": null,
          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/db272720_z.jpg",
          "sellerUrlMethod": "GET",
          "seq": 1
        },
        {
          "description": null,
          "imageGroup": "VIEW",
          "representative": false,
          "sellerImageCategory": null,
          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/d9b82d75_z.jpg",
          "sellerUrlMethod": "GET",
          "seq": 2
        },
        {
          "description": null,
          "imageGroup": "VIEW",
          "representative": false,
          "sellerImageCategory": null,
          "sellerUrl": "https://i.travelapi.com/hotels/39000000/38410000/38400600/38400568/6ad13a4d_z.jpg",
          "sellerUrlMethod": "GET",
          "seq": 3
        },
        {
          "description": null,
          "imageGroup": "ROOM",
          "representative": false,
          "sellerImageCategory": null,
          "sellerUrl": "https://i.travelapi.com/hotels/15000000/14740000/14736800/14736767/3394096f_z.jpg",
          "sellerUrlMethod": "GET",
          "seq": 4
        }
      ],
      "instantBooking": true,
      "introduction": "product introduction - 2",
      "localAddress": null,
      "localName": "假日酒店_2",
      "name": "하이 인_update_3",
      "nation": "CN",
      "nearbyLandmarks": [
        {
          "distance": 1,
          "distanceUnit": "KILOMETER",
          "latitude": 31,
          "longitude": 121,
          "name": "nearbyLandmark 1"
        },
        {
          "distance": 500,
          "distanceUnit": "METER",
          "latitude": 31.1,
          "longitude": 121.1,
          "name": "nearbyLandmark 1"
        }
      ],
      "notice": "product notice - 2",
      "publicTransportInfo": "public transport infomation - 2",
      "refundByBusinessDay": true,
      "regionKeyword": "Shanghai",
      "representativePhone": "010-2345-6789",
      "reservationNotifications": [
        {
          "contactDescription": "reservation notification 1 - 2",
          "contactInfo": "010-2345-6789",
          "type": "PHONE"
        }
      ],
      "searchTags": [
        "shanghai",
        "disney"
      ],
      "sellerProductId": "seller product 1",
      "themes": [
        "ACCOMMODATION_THEME_65"
      ],
      "trafficInfo": "traffic info - 2",
      "usageGuide": "usage guide - 2",
      "usageNotice": "usage notice - 2"
    }
  ]
}
                        `}
                    </pre>
                            </div>
                        </div>
                    </div>
                </div>

                {/*<div className="table-responsive mt40">*/}
                {/*    <h4>Response Specifications</h4>*/}
                {/*    <table className="table table-striped">*/}
                {/*        <tbody>*/}
                {/*        <tr>*/}
                {/*            <th>Name</th>*/}
                {/*            <th>Type</th>*/}
                {/*            <th>Description</th>*/}
                {/*        </tr>*/}
                {/*        <tr>*/}
                {/*            <td>code</td>*/}
                {/*            <td>String</td>*/}
                {/*            <td>응답 코드</td>*/}
                {/*        </tr>*/}
                {/*        <tr>*/}
                {/*            <td>message</td>*/}
                {/*            <td>String</td>*/}
                {/*            <td>응답 메세지</td>*/}
                {/*        </tr>*/}
                {/*        <tr>*/}
                {/*            <td>data</td>*/}
                {/*            <td>Long</td>*/}
                {/*            <td>여행상품ID</td>*/}
                {/*        </tr>*/}
                {/*        </tbody>*/}
                {/*    </table>*/}
                {/*</div>*/}
                <div className="table-responsive mt40">
                    <h4>Response Specifications</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>code</td>
                            <td>String</td>
                            <td>응답 코드</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>message</td>
                            <td>String</td>
                            <td>응답 메세지</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>LodgingResultResponseDto</td>
                            <td>List{'<SuccessOrFail>'}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>(success)</td>
                            <td>LodgingResponseDto</td>
                            <td></td>
                        </tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>travelProductId</td><td>Long</td><td>여행상품 아이디</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>sellerProductId</td><td>String</td><td>셀러에서 상품을 관리하기 위해 사용한 유닉 아이디</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>name</td><td>String</td><td>숙박시설 이름</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>rooms</td><td>List{'<LodgingRoomResponseDto>'}</td><td></td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>travelItemId</td><td>Long</td><td>여행상품 id</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>sellerRoomId</td><td>String</td><td>셀러 웹사이트의 룸 아이디</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>name</td><td>String</td><td>셀러 웹사이트의 룸명</td></tr>

                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>rates</td><td>List{'<LodgingRateResponseDto>'}</td><td></td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>rateId</td><td>Long</td><td>rate id</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>sellerRateId</td><td>String</td><td>웹사이트의 요금 아이디</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level4}>name</td><td>String</td><td>셀러 웹사이트의 요금명</td></tr>


                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>(fail)</td>
                            <td>LodgingErrorResponseDto</td>
                            <td></td>
                        </tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>id</td><td>String</td><td>셀러 웹사이트의 프로덕트 아이디</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>name</td><td>String</td><td>셀러 웹사이트의 프로덕트명</td></tr>
                        <tr><td>&nbsp;</td><td>&nbsp;</td><td colSpan={level3}>reason</td><td>String</td><td>오류 사유</td></tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title">응답값 예시</h3>
                        </div>
                        <div className="panel-body">
                    <pre className="ty01">
                        {`
{
    "code": 200,
    "message": "Lodging product update request successfully received",
    "data": {
        "success": [
            {
                "travelProductId": 579968859277099012,
                "sellerProductId": "seller product 1",
                "name": "하이 인_update_1",
                "rooms": null,
                "rates": null
            },
            {
                "travelProductId": 577175634321604613,
                "sellerProductId": "seller product 1",
                "name": "하이 인_update_3",
                "rooms": null,
                "rates": null
            }
        ],
        "fail": []
    }
}
                        `}
                    </pre>
                        </div>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>HTTP CODE</th>
                            <th>message</th>
                            <th>설명</th>
                        </tr>
                        <tr>
                            <td>400</td>
                            <td>Bad request</td>
                            <td>요청 파라미터 값이 정확하지 않을 경우에 발생합니다
                                <div>
                                    <a data-toggle="collapse" href="#errorMessagesforCreateProduct">400 Error Messages</a>
                                </div>
                                <div id="errorMessagesforCreateProduct" className="panel-collapse collapse">
                                    <div className="panel-body">
                                        {/*<li>이넘 타입 {'${enumClazz.getSimpleName()}'}에 대한 무효 문자열 값</li>*/}
                                        {/*<li>무효 display category code  </li>*/}
                                        {/*<li>images가 비어있을 수 없음</li>*/}
                                        {/*<li>대표 이미지 단 한장만 허용 가능</li>*/}
                                        {/*<li>국내 여행에 대한 locations가 비어있으면 안됨 </li>*/}
                                        {/*<li>landNumberAddress중 하나와 roadNameAddress를 제공해야함</li>*/}
                                        {/*<li>무효 seqs  </li>*/}
                                        {/*<li>format이 IMAGE가 아닌 경우 content를 반드시 제공해야함</li>*/}
                                        {/*<li>format이 IMAGE인 경우 sellerUrl를 반드시 제공해야함</li>*/}
                                        {/*<li>travelType 및 productDetailType가 일치하지 않음</li>*/}
                                        {/*<li>instantBooking이 false인 경우 estimatedBookingDuration이 0보다 크고 72보다 작거나 같아야됨</li>*/}
                                        {/*<li>연락처에 대표 전화 번호가 하나 있어야함 </li>*/}
                                        {/*<li>무효 travel ticket feature id </li>*/}
                                        {/*<li>무효 travel ticket item feature id </li>*/}
                                        {/*<li>무효 travel ticket feature value </li>*/}
                                        {/*<li>무효 travel ticket item feature value </li>*/}
                                        {/*<li>무효 일자/시간 포맷, 포맷이 {'{pattern}'}이어야함</li>*/}
                                        {/*<li>판매 시작일은 판매 종료일보다 늦지 않아야함</li>*/}
                                        {/*<li>상품 inventoryType이 PERIOD인 경우 usePeriod가 NULL이면 안됨</li>*/}
                                        {/*<li>inventoryType이 DAILY인 경우 usePeriod가 불필요함</li>*/}
                                        {/*<li>publication은 null이 아니어야함</li>*/}
                                        {/*<li>inventoryType을 제공해야함</li>*/}
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>401</td>
                            <td>Unauthorized Error</td>
                            <td>잘못된 인증 정보</td>
                        </tr>
                        <tr>
                            <td>403</td>
                            <td>Forbidden Error</td>
                            <td>클라이언트 에서 인증을 제공하였으나 접속 허가를 받지 못했을 경우에 발생합니다.</td>
                        </tr>
                        <tr>
                            <td>410</td>
                            <td>The resource has been permanently deleted</td>
                            <td>리소스가 삭제되었을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>412</td>
                            <td>Precondition failed</td>
                            <td>전제조건이 충족하지 않아 요청이 처리되지 않을 경우에 발생합니다</td>
                        </tr>
                        <tr>
                            <td>429</td>
                            <td>Too many requests</td>
                            <td>요청이 많을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>504</td>
                            <td>API Gateway response timeout</td>
                            <td>API 게이트웨이 응답시간 초과할 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>521</td>
                            <td>API provider server has error</td>
                            <td>API 프로바이더 서버에 에러가 있을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>524</td>
                            <td>API provider to API gateway connection response timeout</td>
                            <td>API 프로바이더에서 API 게이트웨이 연결 응답 시간 초과할 경우 발생합니다</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/LodgingAPIContent/LodgingProductAPI/UpdateLodgingProducts.jsx